<template>
  <div class="obs_container obs_experience">
    <h2 class="obs_heading typo-h2 text-light-high text-center">{{ $t("onboardingStep.experience.title") }}</h2>
    <p class="obs_sub-heading typo-title1 text-light-low text-center">{{ $t("onboardingStep.experience.subtitle") }}</p>
    <div class="obs_body height473">
      <div class="col-5 col-sm-8 mx-auto">
        <div class="obs_body-experience row">
          <div class="col-6 mt-3 no_padding_left">
            <div class="obs_experience-item" :class="{ selected: currentSelect == $t('onboardingStep.experience.level1.key') }" @click="selectItem($t('onboardingStep.experience.level1.key'))">
              <svg width="41" height="32" viewBox="0 0 41 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path id="main_stroke" opacity="0.3" d="M2.27853 1.5L20.5 29.266L38.7215 1.5H2.27853Z" stroke="#3C67FF" stroke-width="3" />
              </svg>
              <h4 class="typo-paragraph16 text-light-high weight-400">{{ $t("onboardingStep.experience.level1.title") }}</h4>
              <p class="text-small text-light-low">{{ $t("onboardingStep.experience.level1.subtitle") }}</p>
            </div>
          </div>
          <div class="col-6 mt-3 no_padding_right">
            <div class="obs_experience-item" :class="{ selected: currentSelect == $t('onboardingStep.experience.level2.key') }" @click="selectItem($t('onboardingStep.experience.level2.key'))">
              <svg width="49" height="48" viewBox="0 0 49 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <rect id="main_stroke" opacity="0.3" x="13" y="8.5" width="31" height="31" stroke="#0A3BE7" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path id="fixed_color" d="M10.9847 44.1303C12.1677 45.9503 14.8323 45.9503 16.0153 44.1303L23.4873 32.635C24.7845 30.6392 23.3523 28 20.9719 28H6.02806C3.64774 28 2.21548 30.6392 3.51273 32.635L10.9847 44.1303Z" fill="currentColor" />
              </svg>
              <h4 class="typo-paragraph16 text-light-high weight-400">{{ $t("onboardingStep.experience.level2.title") }}</h4>
              <p class="text-small text-light-low">{{ $t("onboardingStep.experience.level2.subtitle") }}</p>
            </div>
          </div>
          <div class="col-6 mt-3 no_padding_left">
            <div class="obs_experience-item" :class="{ selected: currentSelect == $t('onboardingStep.experience.level3.key') }" @click="selectItem($t('onboardingStep.experience.level3.key'))">
              <svg width="49" height="48" viewBox="0 0 49 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path id="main_stroke" opacity="0.3" d="M25.4002 6.80014C24.8668 6.39995 24.1332 6.39995 23.5998 6.80014L16.0946 12.4309L8.42014 17.8288C7.8747 18.2125 7.64802 18.9101 7.86379 19.5411L10.8997 28.419L13.6619 37.3859C13.8582 38.0231 14.4517 38.4543 15.1184 38.4441L24.5 38.3002L33.8816 38.4441C34.5483 38.4543 35.1418 38.0231 35.3381 37.3859L38.1003 28.419L41.1362 19.5411C41.352 18.9101 41.1253 18.2125 40.5799 17.8288L32.9054 12.4309L25.4002 6.80014Z" stroke="#0A3BE7" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <rect id="fixed_color" x="27.5" y="27" width="18" height="18" rx="3" fill="currentColor" />
              </svg>
              <h4 class="typo-paragraph16 text-light-high weight-400">{{ $t("onboardingStep.experience.level3.title") }}</h4>
              <p class="text-small text-light-low">{{ $t("onboardingStep.experience.level3.subtitle") }}</p>
            </div>
          </div>
          <div class="col-6 mt-3 no_padding_right">
            <div class="obs_experience-item" :class="{ selected: currentSelect == $t('onboardingStep.experience.level4.key') }" @click="selectItem($t('onboardingStep.experience.level4.key'))">
              <svg width="49" height="48" viewBox="0 0 49 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path id="main_stroke" opacity="0.3" d="M25.0698 38.0515C24.7878 38.3384 24.4023 38.5 24 38.5C23.5977 38.5 23.2122 38.3384 22.9302 38.0515L14.2947 29.2654L5.46468 20.8429C4.91127 20.315 4.84362 19.4553 5.30764 18.8474L11.992 10.0899C12.2758 9.71814 12.7167 9.5 13.1844 9.5H23.4167H34.8156C35.2833 9.5 35.7242 9.71814 36.008 10.0899L42.6924 18.8474C43.1564 19.4553 43.0887 20.315 42.5353 20.8429L33.7053 29.2654L25.0698 38.0515Z" stroke="#0A3BE7" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path id="fixed_color" d="M34.8999 20.4502C35.2555 20.1834 35.7445 20.1834 36.1001 20.4502L40.2023 23.5279L44.3969 26.4782C44.7605 26.734 44.9117 27.1991 44.7678 27.6197L43.1085 32.4721L41.5987 37.3732C41.4678 37.798 41.0722 38.0855 40.6277 38.0787L35.5 38L30.3723 38.0787C29.9278 38.0855 29.5322 37.798 29.4013 37.3732L27.8915 32.4721L26.2322 27.6197C26.0883 27.1991 26.2395 26.734 26.6031 26.4782L30.7977 23.5279L34.8999 20.4502Z" fill="currentColor" />
              </svg>
              <h4 class="typo-paragraph16 text-light-high weight-400">{{ $t("onboardingStep.experience.level4.title") }}</h4>
              <p class="text-small text-light-low">{{ $t("onboardingStep.experience.level4.subtitle") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="obs_footer">
      <button type="button" class="obs_btn disabled" v-if="!isFormValid" v-popover:tooltip.top="$t('onboardingStep.experience.tooltip')">{{ $t("onboardingStep.experience.button") }}</button>

      <button type="button" class="obs_btn" v-if="isFormValid" @click="submitForm">{{ $t("onboardingStep.experience.button") }}</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { mutations } from "@/store/onboarding/types.js";
import obsLocalData from "@/utils/obsLocalData.js";
export default {
  name: "Experience",
  props: {
    userName: String,
    step: Number
  },
  data() {
    return {
      currentSelect: "",
      startTime: Date,
      endTime: Date
    };
  },
  computed: {
    ...mapState("onboarding", {
      experience: state => state.experience
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    isFormValid() {
      let result = false;
      if (this.currentSelect) {
        result = true;
      } else {
        result = false;
      }
      return result;
    }
  },
  created() {
    setTimeout(() => {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      if (obsLocalData.check(shopifyDomain)) {
        const lastSurvey = obsLocalData.get(shopifyDomain);
        if (lastSurvey && lastSurvey.store && lastSurvey.store.experience) {
          this.initData(lastSurvey.store.experience);
        }
      } else {
        this.initData(this.experience);
      }
    }, 300);
    this.startTime = new Date().getTime();
  },
  methods: {
    ...mapMutations("onboarding", {
      obsExperience: mutations.OBS_EXPERIENCE
    }),
    selectItem: function(data) {
      this.currentSelect = data;
    },
    submitForm() {
      this.endTime = new Date().getTime();
      const timeCounter = this.endTime - this.startTime;
      const dataStep = {
        data: this.currentSelect,
        time: timeCounter
      };
      this.obsExperience(dataStep);
      const shopifyDomain = this.shopInfo.shopifyDomain;
      obsLocalData.set(dataStep, "experience", shopifyDomain);
      obsLocalData.set(this.step, "currentStep", shopifyDomain);

      this.nextStep();
    },
    nextStep() {
      this.$emit("next", this.step);
    },
    initData(experience) {
      this.currentSelect = experience.data;
    }
  }
};
</script>

<style lang="scss" scoped>
.obs_experience {
  width: 100%;
  height: 100%;
}
</style>
